module.exports = __webpack_public_path__ + "static/media/right-arrow-light-theme.7d79e5ab.svg";